import React, { Dispatch, SetStateAction, useEffect, useRef, useState } from 'react';
import CustomModalHeader from '../../../Common/customComponents/CustomModalHeader.tsx';
import CustomTable from '../../../Common/customComponents/CustomTable.tsx';
import { BasicModalV2, TextButton } from '../../../../components';
import ButtonPlusIcon from '/assets/icon/global/button-plus-icon.svg';
import { ptwApi } from '../../../../api/ptw.api.ts';
import CustomText from '../../../Common/customComponents/CustomText.tsx';
import FormTabXBlack from '/assets/icon/global/form-tab-x-black.svg';
import { commonMsg } from '../../../../utils/globalUtil.tsx';
import { useAsync } from '../../../../hooks';

interface IProps {
  setIsModalOpen: Dispatch<SetStateAction<boolean>>;
  isModalOpen: boolean;
  title?: string;
  onActionCallback?: any;
  selectedList?: any;
  searchKeyword?: string;
  settingApproverMSeq?: number;
}

const UserSearchModal = (props: IProps) => {
  /*일반*/
  const [searchData, setSearchData] = useState<any>({});
  const { callAsync, showAlarm, closeAlarm } = useAsync();

  /*테이블관련*/
  const [gridData, setGridData] = useState<any>([]);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [totalCount, setTotalCount] = useState<number>(0);
  const [tableSort, setTableSort] = useState<any>({});
  const [pageSize, setPageSize] = useState<number>(10);
  const [selectedRow, setSelectedRow] = useState<any>({});
  const [checkedList, setCheckedList] = useState<any>([]);

  const isFirst = useRef(true);
  useEffect(() => {
    const t = setTimeout(() => {
      if (isFirst.current) {
        isFirst.current = false;
        return;
      }

      search();
    }, 100);

    return () => clearTimeout(t);
  }, [searchData]);

  useEffect(() => {
    if (props.isModalOpen) {
      if (props.searchKeyword) {
        setSearchData({ searchText: props.searchKeyword });
      }
      search();
    } else {
      setGridData([]);
      setSearchData({});
    }
  }, [props.isModalOpen]);

  const handleChange = (e: any) => {
    setSearchData((oData: any) => {
      return { ...oData, [e.target.name]: e.target.value };
    });
  };

  const search = () => {
    let exceptionList = [];
    console.log('props.selectedList', props.selectedList);
    if (props.selectedList) {
      exceptionList = props.selectedList.map((item: any) => item.userId);
    }

    const param = {
      ...searchData,
      exceptionList: exceptionList
    };

    if (props.settingApproverMSeq) {
      param.settingApproverMSeq = props.settingApproverMSeq;
    }

    ptwApi.getSettingApprovalUserSearchList(param).then(function (r) {
      setGridData(r.resultList);
      setTotalCount(r.resultList[0]?.totalCount);
    });
  };

  const modalClose = () => {
    props.setIsModalOpen(false);
  };

  const columns = [
    {
      column: 'userNm',
      label: 'Name',
      align: 'center',
      sort: true,
      size: 100,
      type: 'custom',
      custom: (row: any) => {
        return (
          <div className={'flex-row gap-2 text-align-center pl-5'}>
            <span
              className={'user-search-modal-img-span'}
              style={{ backgroundImage: 'url(' + row.userFileUrl + ')' }}
            ></span>
            <span className={'center'}>{row.userNm}</span>
          </div>
        );
      }
    },
    {
      column: 'companyNm',
      label: 'Company',
      align: 'center',
      sort: true,
      size: 100
    },
    {
      column: 'designationNm',
      label: 'Designation',
      align: 'center',
      sort: true,
      size: 100
    },
    {
      column: 'workerType',
      label: 'User Type',
      align: 'center',
      sort: true,
      size: 100
    }
  ];

  const save = () => {
    if (checkedList.length === 0) {
      commonMsg.alert(showAlarm, closeAlarm, 'Warning', 'No items selected.', null);
      return;
    }

    props.setIsModalOpen(false);
    props.onActionCallback(checkedList);
  };

  const deleteItem = (targetItem: any) => {
    setCheckedList((prevList: any) =>
      prevList.filter((oItem: any) => oItem.userId !== targetItem.userId)
    );

    setGridData((prevData: any[]) => {
      return prevData.map((row) => {
        if (row.userId === targetItem.userId) {
          return { ...row, isCheck: false };
        }
        return row;
      });
    });
  };

  return (
    <BasicModalV2 open={props.isModalOpen} onClose={() => props.setIsModalOpen(false)}>
      <CustomModalHeader title={props.title || 'User Search'} modalClose={modalClose} />
      <div
        className={'custom-modal-body user-search-modal'}
        style={{ width: '900px', height: '650px' }}
      >
        <div className={'search-box pt-0 pb-0'}>
          <div className={'search-item-list'}>
            <div className={'search-item'}>
              <CustomText
                onChange={handleChange}
                name={'searchText'}
                value={searchData?.searchText}
                isBtnClose={false}
                isBtnSearch={true}
                style={{ width: '300px' }}
                placeholder={'Enter search query.'}
                defaultValue={props.searchKeyword}
              />
            </div>
          </div>
        </div>
        <div className={'grid-box'}>
          <CustomTable
            columns={columns}
            data={gridData}
            setData={setGridData}
            isPaging={true}
            isCheck={true}
            pageSize={pageSize}
            setPageSize={setPageSize}
            totalCount={totalCount}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            setTableSort={setTableSort}
            className={'min-w-100'}
            setSelectedRow={setSelectedRow}
            checkedList={checkedList}
            setCheckedList={setCheckedList}
            bodyHeight={300}
            dbClick={(row) => {}}
          />
        </div>
        <div>
          <div className={'selected-item-list'}>
            {checkedList.map((item: any, index: number) => (
              <div className={'selected-item'} key={index}>
                <span>{item.userNm}</span>
                <a
                  onClick={() => {
                    deleteItem(item);
                  }}
                >
                  <img
                    src={FormTabXBlack}
                    alt={'close'}
                    style={{ width: '15px', height: '15px' }}
                  />
                </a>
              </div>
            ))}
          </div>
        </div>
        <div className={'button-box'}>
          <TextButton
            variant="contained"
            style={{ height: '40px', gap: '5px' }}
            onClick={() => {
              save();
            }}
          >
            OK ({checkedList.length})
          </TextButton>
        </div>
      </div>
    </BasicModalV2>
  );
};

export default UserSearchModal;
